export const MODAL_CONFIRMATION_OPEN = 'MODAL_CONFIRMATION_OPEN'
export const MODAL_CONFIRMATION_CLOSE = 'MODAL_CONFIRMATION_CLOSE'
export const MODAL_CONFIRMATION_CANCEL = 'MODAL_CONFIRMATION_CANCEL'
export const MODAL_CONFIRMATION_SAVE_CHANGES = 'MODAL_CONFIRMATION_SAVE_CHANGES'
export const MODAL_CONFIRMATION_VALIDATE = 'MODAL_CONFIRMATION_VALIDATE'
export const MODAL_CONFIRMATION_RESET = 'MODAL_CONFIRMATION_RESET'

function open(newState) {
  return {
    type: MODAL_CONFIRMATION_OPEN,
    newState,
    isModalConfirmationOpen: true,
  }
}

function cancel() {
  return {
    type: MODAL_CONFIRMATION_CANCEL,
    isModalConfirmationOpen: false,
  }
}

function close() {
  return {
    type: MODAL_CONFIRMATION_CLOSE,
  }
}

function saveChanges(newState) {
  return {
    type: MODAL_CONFIRMATION_SAVE_CHANGES,
    isTxChangesSaved: true,
    newState,
  }
}

function validate(isValidated) {
  return {
    type: MODAL_CONFIRMATION_VALIDATE,
    isValidated,
  }
}

function reset() {
  return {
    type: MODAL_CONFIRMATION_RESET,
  }
}

export function openModalConfirmation(status) {
  return (dispatch) => {
    dispatch(open(status))
  }
}

export function closeModalConfirmation() {
  return (dispatch) => {
    dispatch(close())
  }
}

export function cancelModalConfirmation() {
  return (dispatch) => {
    dispatch(cancel())
  }
}

export function saveChangesModalConfirmation(status) {
  return (dispatch) => {
    dispatch(saveChanges(status))
  }
}

export function validateModalConfirmation(isValid) {
  return (dispatch) => {
    dispatch(validate(isValid))
  }
}

export function resetModalConfirmation() {
  return (dispatch) => {
    dispatch(reset())
  }
}
